
import {environmentService} from '../services/EnvironmentService';

const ONE_MINUTE = 1000 * 60;
const ONE_HOUR = ONE_MINUTE * 60;
const ONE_DAY = ONE_HOUR * 24;

export const EXPIRY_HANDLER_KEY = {
  ONE_DAY: 'ONE_DAY',
  SHORT_SESSION: 'SHORT_SESSION',
  BUILD_VERSION: 'BUILD_VERSION',
  TRANSLATIONS: 'TRANSLATIONS'
};


/**
 * Request is expired if cached more than a day ago
 */
export const oneDayExpiryHandler = {
  isExpired: function(request) {
    return Date.now() - ONE_DAY > request.meta.cacheTimestamp;
  },
  setMeta: function(request) {
    request.meta.cacheTimestamp = Date.now();
  }
};

export const buildVersionExpiryHandler = {
  isExpired: function(request) {
    return request.meta.buildVersion !== environmentService.getBuildVersion();
  },
  setMeta: function(request) {
    request.meta.buildVersion = environmentService.getBuildVersion();
  }
};

export const translationsExpiryHandler = {
  isExpired: function(request) {
    if (request.meta.translationsCacheKey === environmentService.getTranslationsCacheKey()) {
      return buildVersionExpiryHandler.isExpired(request);
    } else {
      return false;
    }
  },
  setMeta: function(request) {
    request.meta.translationsCacheKey = environmentService.getTranslationsCacheKey();
    buildVersionExpiryHandler.setMeta(request);
  }
};

/**
 * Keep around for a few minutes
 */
export const shortSessionExpiryHandler = {
  isExpired: function(request) {
    return Date.now() - (ONE_MINUTE * 5) > request.meta.shortSessionTimestamp;
  },
  setMeta: function(request) {
    request.meta.shortSessionTimestamp = Date.now();
  }
};

export const expiryHandlers = {
  [EXPIRY_HANDLER_KEY.ONE_DAY]: oneDayExpiryHandler,
  [EXPIRY_HANDLER_KEY.SHORT_SESSION]: shortSessionExpiryHandler,
  [EXPIRY_HANDLER_KEY.BUILD_VERSION]: buildVersionExpiryHandler,
  [EXPIRY_HANDLER_KEY.TRANSLATIONS]: translationsExpiryHandler
};



// WEBPACK FOOTER //
// ./assets/utilities/requestExpiryHandlers.js